import React, { useEffect, useRef, useState } from 'react';
import M_PER_CUSTOM_02 from './M_PER_CUSTOM_02';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Commons from '../../../../Services/Common/Common';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { BaseInfoActions } from '../../../../Reducer/BaseInfoReducer';
import useFcmHandler from '../../../../Hooks/useFcmHandler';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { NavBarInfoActions } from '../../../../Reducer/NavBarInfoReducer';
import {
  useDelete1,
  useSave1,
  useSearch1,
  useSearch2,
} from './M_PER_CUSTOM_02_Query';
import { useDelete } from '../../../../Hooks/useDelete';
import { PermitActions } from '../../../../Reducer/PermitReducer';
import { useSave } from '../../../../Hooks/useSave';
import { M_PER_CUSTOM_02_Schema } from './M_PER_CUSTOM_02_Schema';
import useFileUpload from '../../../../Hooks/useFileUpload';
import { useAppNavigate } from '../../../../Hooks/back/useAppNavigate';

// 작업허가서 상세 조회 페이지 (반려, 승인 동작)
export default function M_PER_CUSTOM_02F() {
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const { baseInfo } = useSelector((state) => state.permit);
  const dispatch = useDispatch();
  const { id } = useParams();
  const { navigate } = useAppNavigate();
  const signatureCanvas = useRef();
  const sendFcm = useFcmHandler();
  // UI 상태 관리 (상위로 이동)
  const [activeIndex, setActiveIndex] = useState(0); // 탭 이동 상태
  const [isBaseChecked, setIsBaseChecked] = useState(false); // 기본 작성 정보 체크
  const [isChecklistChecked, setIsChecklistChecked] = useState(false); // 작업별 사전체크 항목 체크
  const [completedSections, setCompletedSections] = useState([]); // 완료된 섹션들
  const [isComplete, setIsComplete] = useState(false);
  const [mode, setMode] = useState();
  const { createPreviewItem, SaveLogicFile } = useFileUpload({
    oldFilePathField: 'oldPath',
    newFileNameField: 'saveName',
    getTargetPath: () =>
      `Business/${baseInfo.custCd}/SAF_BASIC_02/${Commons.DecryptoAES(userInfo.userid)}`,
  });

  useEffect(() => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('작업 허가서'));
    dispatch(CommonActions.setActiveStep(0));
    Search1({ pmCd: id });
  }, [dispatch, id]);

  // 작업허가서 FCM (gubun : 2 : 안전관리자가 서명 후 알람, 1 : 결재승인자이 서명 후 알람)
  const handleSignRequest = async (gubun) => {
    dispatch(BaseInfoActions.setFcmReceptionPayload(''));

    if (gubun === '1') {
      await sendFcm({
        targetUserId: baseInfo.safetyApproverId,
        requestUserId: userInfo.userid,
        body: '작업 허가서 요청입니다.',
        status: '요청',
        codeGroup: 'AL_002_001',
        title: '작업허가서',
        route: '/M_Permit',
        responseData: baseInfo.pmCd,
      });
      return;
    }

    if (gubun === '0') {
      await sendFcm({
        targetUserId: baseInfo.userId,
        requestUserId: userInfo.userid,
        body: '작업허가서 반려 안내',
        status: '반려',
        codeGroup: 'AL_002_002',
        title: '작업허가서',
        route: '/M_Permit',
        responseData: baseInfo.pmCd,
      });
      return;
    }

    if (gubun === '2') {
      await sendFcm({
        targetUserId: baseInfo.userId,
        requestUserId: userInfo.userid,
        body: '작업허가서 승인이 완료되었습니다.',
        status: '최종승인',
        codeGroup: 'AL_002_003',
        title: '작업허가서',
        route: '/M_Permit',
        responseData: baseInfo.pmCd,
      });
      return;
    }
  };
  const { run: Search1 } = useSearch1({
    onSuccess: (data) => {
      if (!data || data.length === 0) return;
      const resBaseInfo = data[0];

      const parseItemList = (listStr, type) => {
        if (!listStr) return [];
        return listStr.split('||').map((item) => {
          const [code, name, checked] = item.split('|');
          return {
            [type === 'risk'
              ? 'riskCode'
              : type === 'equip'
                ? 'workEquipCode'
                : 'preparationCode']: code,
            [type === 'risk'
              ? 'riskNm'
              : type === 'equip'
                ? 'workEquipNm'
                : 'preparationNm']: name,
            itemCheck: checked === 'Y' ? 'Y' : '',
          };
        });
      };

      const risks = parseItemList(resBaseInfo.riskItemsList, 'risk');
      const equips = parseItemList(resBaseInfo.equipmentItemsList, 'equip');
      const preparations = parseItemList(
        resBaseInfo.preparationItemsList,
        'prep'
      );

      dispatch(
        PermitActions.setCodeInfo({
          risks,
          equips,
          preparations,
        })
      );

      dispatch(
        PermitActions.setBaseInfo({
          ...resBaseInfo,
          permissionDate: resBaseInfo.permissionDate?.split(' ')[0] || '',
          workType: resBaseInfo.workTypeCode || '',
          savedRiskCodes: resBaseInfo.selectedRiskCodes?.split(',') || [],
          savedEquipCodes: resBaseInfo.selectedEquipmentCodes?.split(',') || [],
          savedPrepCodes:
            resBaseInfo.selectedPreparationCodes?.split(',') || [],
        })
      );
    },
  });

  const { mutateAsync: save1Async } = useSave1();

  const { run: Save1 } = useSave({
    menuId: 'M_PER_CUSTOM_02',
    schema: M_PER_CUSTOM_02_Schema,

    saveData: (params) => ({
      ...params,
      baseInfo,
    }),

    fileSave: async (requestRows, params) => {
      const { gubun, signFile } = params;
      if (gubun !== '0' && signFile) {
        const fileResult = await createPreviewItem(signFile);
        const finalPath = await SaveLogicFile([fileResult]);
        console.log(finalPath);

        if (finalPath) {
          return {
            depSignPath: gubun === '1' ? finalPath : '',
            smSignPath: gubun === '2' ? finalPath : '',
          };
        }
      }
      return {};
    },

    requestSave: async (requestRows) => {
      return await save1Async(requestRows[0]);
    },

    onSuccess: async ({ saveDetailData, requestRows }) => {
      const context = requestRows[0];
      const { gubun } = context;
      const isLastSign = saveDetailData?.[0]?.isLastSign;

      if (gubun === '0') await handleSignRequest('0');
      else if (gubun === '1' && isLastSign === 'Y') {
        await handleSignRequest('1');
        setIsComplete(true);
      } else if (gubun === '2') {
        await handleSignRequest('2');
        setIsComplete(true);
      }

      Search1({ pmCd: id });

      dispatch(
        showSnackbar({
          message:
            gubun === '0'
              ? '반려 처리가 완료되었습니다.'
              : '승인 처리가 완료되었습니다.',
          type: 'success',
        })
      );
    },
  });

  const { runAsync: Delete1Async } = useDelete1();

  const { run: Delete1 } = useDelete({
    menuId: 'M_PER_CUSTOM_02',
    requestDelete: () => Delete1Async({ pmCd: id }),
    onSuccess: () => {
      dispatch(
        showSnackbar({
          message: '작업허가서가 삭제되었습니다.',
          type: 'success',
        })
      );

      navigate('/M_Permit');
    },
  });

  return (
    <div className="wrap">
      <M_PER_CUSTOM_02
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
        isBaseChecked={isBaseChecked}
        setIsBaseChecked={setIsBaseChecked}
        isChecklistChecked={isChecklistChecked}
        setIsChecklistChecked={setIsChecklistChecked}
        completedSections={completedSections}
        setCompletedSections={setCompletedSections}
        isComplete={isComplete}
        setIsComplete={setIsComplete}
        mode={mode}
        setMode={setMode}
        // 함수
        signatureCanvas={signatureCanvas}
        Save1={Save1}
        Delete1={Delete1}
      />
    </div>
  );
}
